import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Story } from "@/components/Story";
import { Kitchens } from "@/components/Kitchens";
import { EsakSection } from "@/components/EsakSection";
import { EsakMenu } from "@/components/EsakMenu";
import { OffersStrip } from "@/components/OffersStrip";
import { Gallery } from "@/components/Gallery";
import { ReviewsStrip } from "@/components/ReviewsStrip";
import { InstagramSection } from "@/components/InstagramSection";
import { EventsStrip } from "@/components/EventsStrip";
import { ReserveSection } from "@/components/ReserveSection";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import AdminPage from "@/components/AdminPage";
import PetsPage from "@/components/PetsPage";

const MARQUEE_WORDS = ["Escape", "Calm", "Flavour", "Nature", "Togetherness", "Pause", "Harmony", "Bloom", "Savour"];

const Site = () => (
    <>
        <Navbar />
        <main>
            <Hero />
            <div className="bg-[#F0841B] py-4 overflow-hidden" data-testid="marquee-strip">
                <div className="marquee-track flex whitespace-nowrap gap-10 w-max">
                    {[...MARQUEE_WORDS, ...MARQUEE_WORDS].map((w, i) => (
                        <span key={i} className="font-serif-brand italic text-lg text-white/90 flex items-center gap-10">
                            {w} <span className="text-white/50 not-italic text-xs">✦</span>
                        </span>
                    ))}
                </div>
            </div>
            <Story />
            <Kitchens />
            <EsakSection />
            <EsakMenu />
            <OffersStrip />
            <Gallery />
            <ReviewsStrip />
            <InstagramSection />
            <EventsStrip />
            <ReserveSection />
        </main>
        <Footer />
        <WhatsAppButton />
    </>
);

function App() {
    return (
        <div className="App">
            <div className="noise-overlay" />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Site />} />
                    <Route path="/pets" element={<><PetsPage /><WhatsAppButton /></>} />
                    <Route path="/admin" element={<AdminPage />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
        </div>
    );
}

export default App;
